import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FooterNavigation, Header, PaginationHelper, TitleBar, Dialog } from "webapp/components";
import { CARSMemberInformationForm } from "webapp/components/Partner/CARS/CARSMemberInformationForm";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";

export default function CARSMemberInformation(props) {
  const { t } = useTranslation();
  const [memberInfo, setMemberInfo] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [showSelectUserModal, setShowSelectUserModal] = useState(false);
  const [showMNFInputError, setShowMNFInputError] = useState(false);
  const [showVinError, setShowVinError] = useState(false);
  const [showNotCoveredMsg, setShowNotCoveredMsg] = useState(false);
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [acceptOOPConsent, setAcceptOOPConsent] = useState(false);

  const [MNFMemberInfoData, setMNFMemberInfoData] = useState({
    firstName: props.currState.MemberLookup.firstName || props.currState.FirstName || "",
    lastName: props.currState.MemberLookup.lastName || props.currState.LastName || "",
    phoneNumber: props.currState.MemberLookup.phoneNumber || props.currState.Number || "",
    contractNumber: props.currState.MemberLookup.contractNumber || "",
    vin: props.currState.MemberLookup.vin || props.currState.vin || "",
    purchaseDate: "",
    havingTrouble: false,
    covered: false,
  });
  const [lookupSucceeded, setLookupSucceeded] = useState(false);

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("description.PolicyInformationVerifyHeader")}</strong>
          <br />
        </p>
      </>
    ),
  };

  const onUserNext = (forceAcceptOOP = false) => {
    const isContactSelected =
      selectedContact !== null && (typeof selectedContact === "object" || typeof selectedContact === "undefined");
    console.log("onUserNext", memberInfo, selectedContact, isContactSelected, MNFMemberInfoData);

    console.log("onUserNext MNFMemberInfoData: ", MNFMemberInfoData);

    if (MNFMemberInfoData.havingTrouble && MNFMemberInfoData.vin.length !== 17) {
      setShowVinError(true);
      return;
    }

    const isMNFInputInValid =
      MNFMemberInfoData.havingTrouble &&
      (MNFMemberInfoData.firstName === "" ||
        MNFMemberInfoData.lastName === "" ||
        MNFMemberInfoData.phoneNumber === "" ||
        MNFMemberInfoData.contractNumber === "" ||
        MNFMemberInfoData.purchaseDate === "");

    if (isMNFInputInValid) {
      setShowMNFInputError(true);
      return;
    }

    if (MNFMemberInfoData.havingTrouble) {
      if (!MNFMemberInfoData.covered && !acceptOOPConsent && !forceAcceptOOP) {
        setShowNotCoveredMsg(true);
        return;
      }

      props.context.setState(
        {
          MemberLookup: {
            ...MNFMemberInfoData,
            acceptOOPConsent: acceptOOPConsent || forceAcceptOOP,
          },
          FirstName: MNFMemberInfoData.firstName,
          LastName: MNFMemberInfoData.lastName,
          Number: MNFMemberInfoData.phoneNumber,
          vin: MNFMemberInfoData.vin,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          if (typeof props.onUserNext === "function") {
            props.onUserNext();
          }
          props.context.saveWebAppState(props.context);
        },
      );
      return;
    }

    if (memberInfo && isContactSelected) {
      props.context.setState(
        {
          accountRef: memberInfo.accountRef,
          contactRef: selectedContact?.contactRef,
          last8VIN: memberInfo.last8Vin,
          Year: memberInfo.year,
          Make: memberInfo.make,
          Model: memberInfo.model,
          Color: memberInfo.color,
          allowVehicleInfoEdits: false,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          if (typeof props.onUserNext === "function") {
            props.onUserNext();
          }
          props.context.saveWebAppState(props.context);
        },
      );
    } else {
      setShowSelectUserModal(true);
    }
  };

  const onAcceptNotCovered = () => {
    setShowNotCoveredMsg(false);
    setAcceptOOPConsent(true);
    onUserNext(true);
  };

  const promptCancelService = () => {
    setShowCancelConfirm(true);
  };

  const onConfirmCancelService = () => {
    setShowCancelConfirm(false);
    setShowNotCoveredMsg(false);
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onUserCancel = () => {
    if (MNFMemberInfoData.havingTrouble) {
      promptCancelService();
      return;
    }
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onContractLookupComplete = (success) => {
    devLog("success", success);
    setLookupSucceeded(!!success);
    if (!success) {
      setMNFMemberInfoData((prev) => ({ ...prev, havingTrouble: false }));
    }
  };

  const onHavingTroubleChange = (havingTrouble) => {
    setMNFMemberInfoData((prev) => ({ ...prev, havingTrouble: !!havingTrouble }));
  };

  const onUserSelectMember = (memberInfo, selectedContact) => {
    devLog("onUserSelectMember", memberInfo, selectedContact);
    setMemberInfo(memberInfo);
    setSelectedContact(selectedContact);
  };

  const shouldShowFooter = lookupSucceeded || MNFMemberInfoData.havingTrouble;

  return (
    <>
      <div className="CustCollectPage">
        <Header
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          information={t("BWC.PolicyInformation.PolicyInformationHeader1")}
        />
        <TitleBar data={LocateUserObj} />
        <PaginationHelper context={props.context} />
        <CARSMemberInformationForm
          context={props.context}
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          onUserCancel={onUserCancel}
          onLoad={onContractLookupComplete}
          onMemberInfo={onUserSelectMember}
          onHavingTroubleChange={onHavingTroubleChange}
          MNFMemberInfoData={MNFMemberInfoData}
          setMNFMemberInfoData={setMNFMemberInfoData}
          showVinError={showVinError}
        />
      </div>
      {shouldShowFooter && <FooterNavigation onCancelClick={onUserCancel} onNextClick={onUserNext} />}
      {showSelectUserModal && (
        <Dialog
          title={"DriverMissing"}
          message={"ErrorSelectContacts"}
          buttonTitle={"OK"}
          onClose={() => {
            setShowSelectUserModal(false);
          }}
        />
      )}
      {showMNFInputError && (
        <Dialog
          title={"ErrorMNFInput"}
          message={"ErrorMNFInputMsg"}
          buttonTitle={"OK"}
          onClose={() => {
            setShowMNFInputError(false);
          }}
        />
      )}
      {showNotCoveredMsg && (
        <Dialog
          title={"CoverageExpired"}
          message={"CoverageExpiredMsg"}
          buttonTitle={"CancelCallButton4"}
          primaryMessageButtonClass="footer-cancel-light"
          secondaryButtonTitle={"Accept"}
          secondaryButtonAction={onAcceptNotCovered}
          preventDismiss={true}
          onClose={() => {
            setShowNotCoveredMsg(false);
          }}
        />
      )}
      {showCancelConfirm && (
        <Dialog
          title={"CancelCall1"}
          message={"CancelCall2"}
          buttonTitle={"No"}
          primaryMessageButtonClass="footer-cancel-light"
          secondaryButtonTitle={"Yes"}
          secondaryButtonAction={onConfirmCancelService}
          onClose={() => {
            setShowCancelConfirm(false);
          }}
        />
      )}
    </>
  );
}
